// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"b38783e9","354":"f0868de6","838":"3557c801"}[chunkId] + ".js";
};